import * as ethers from 'ethers'
import { strToWei, weiToStr } from 'modules/blockChain/utils/parseWei'
import type { PoolAsset } from 'modules/pools/constants/poolAssets'

export const required = 'This field is required'

export const greater = (val: string | number, test: number) =>
  Number(val) <= test ? `Should be greater than ${test}` : false

export const notLess = (val: string | number, test: number) =>
  Number(val) < test ? `Can not be less than ${test}` : false

export const notMore = (val: string | number, test: number, asset?: string) =>
  Number(val) > test
    ? `Please specify amount lower than ${test} ${asset}`
    : false

export const weiParsing = (val: string, decimals: number) => {
  if (val.length) {
    try {
      strToWei(val, decimals)
      return false
    } catch (err) {
      return valueParse
    }
  } else {
    return true
  }
}

export const balance = (
  val: string,
  test: ethers.BigNumberish | undefined | null,
  asset: PoolAsset | undefined | null | '',
  assetDecimals: number,
  fieldName: string = 'Amount',
) =>
  weiParsing(val, assetDecimals) ||
  (test && strToWei(val, assetDecimals).gt(test)
    ? `${fieldName} exceeds your balance of ${weiToStr(
        test,
        assetDecimals,
      )} ${asset}`
    : false)

export const POOL_BALANCE_ERROR =
  'The requested amount exceeds available money in the pool. Please reduce requested amount'

export const poolBalance = (
  val: string,
  reserves: ethers.BigNumberish | null | undefined,
  decimals: number,
) =>
  weiParsing(val, decimals) ||
  (reserves && strToWei(val, decimals).gt(reserves)
    ? POOL_BALANCE_ERROR
    : false)

export const valueParse = `The value cannot be parsed`
